<template>
  <q-card flat bordered class="i-fingerprint-list  bg-theme-bg">
    <q-card-section class="i-fingerprint-list-body">
      <q-chip v-for="fp of computedFingerprints" :key="fp.id" clickable v-ripple color="primary" text-color="white" removable
        @remove="removeFingerprint(fp)">
        <!-- <q-icon name="fingerprint" size="2em" /> -->
        <div style="margin:0 0.5em">{{fp.fingerTypeText}}</div>
      </q-chip>
    </q-card-section>
    <q-separator />
    <q-card-actions align="around">
      <i-btn color="action-add" dense icon="fingerprint" label="指纹管理" tooltip-text="录入或删除指纹" @click="dialogs.fingerprint.show=true" />
    </q-card-actions>
    <q-dialog v-model="dialogs.fingerprint.show" persistent>
      <i-fingerprint-manager @cancel="dialogs.fingerprint.show=false" :identity-type="identityType" :identity-id="identityId"
        @update:identityId="$emit('update:identityId', $event)" @updated="reload()" @added="reload()" @removed="reload()"></i-fingerprint-manager>
    </q-dialog>
  </q-card>
</template>

<script>
import { FingerType } from '@/lib/enums'
import _ from 'lodash'

let reloadTimestamp = 0

export default {
  data () {
    return {
      fingerprints: null,
      reloadTimestamp: null,
      dialogs: {
        fingerprint: {
          show: false
        }
      }
    }
  },
  props: {
    identityType: {
      require: true,
      type: Number
    },
    identityId: {
      type: Number
    }
  },
  computed: {
    computedIdentity () {
      return {
        id: this.identityId,
        type: this.identityType
      }
    },
    computedFingerprints () {
      return this.fingerprints?.map(fp => ({
        ...fp,
        fingerTypeText: FingerType.getItemText(fp.fingerType)
      }))
    }
  },
  mounted () {
    this.reload()
  },
  methods: {
    async reload () {
      const timestamp = ++reloadTimestamp
      this.reloadTimestamp = timestamp
      if (!_.isNil(this.identityType) && !_.isNil(this.identityId)) {
        const searchResult = await this.$$api.bis.post('/dic/fingerprint/search', {
          identityType: this.identityType,
          identityId: this.identityId
        })
        if (timestamp === this.reloadTimestamp) {
          searchResult.notifyIfFail()
          if (searchResult.success) {
            this.fingerprints = searchResult.data.fingerprints
          }
        }
      } else {
        this.fingerprints = null
      }
    },
    removeFingerprint (fingerprint) {
      this.$q.dialog({
        title: '提示',
        message: `确定要删除 ${fingerprint.fingerTypeText} 指纹记录 吗？`,
        cancel: { color: 'red' },
        focus: 'cancel'
      }).onOk(async () => {
        const result = await this.$$api.bis.delete(`/dic/fingerprint/${encodeURIComponent(fingerprint.id)}`)
        result.notify(result.success ? '删除成功' : null)
        this.reload()
      })
    }
  },
  watch: {
    computedIdentity () {
      this.reload()
    }
  }
}
</script>

<style lang="scss">
.i-fingerprint-list {
  display: flex;
  flex-flow: column;

  &-body {
    flex-grow: 1;
    display: flex;
    flex-flow: row wrap;
    justify-content: center;
    align-items: center;
    padding: 0.5em !important;
    font-size: 0.2em !important;
  }
}
</style>
